<template>
  <div class="content">
    <div class="ttile">
      富文本
      <p>
        说明：富文本可以输入长篇文字，也可以上传图片、视频、图片都可以做链接到其他页面，图片可以做成很多种形式来显示。
      </p>
    </div>
    <div class="editor">
      <Tinymce v-model="curComponent.html"></Tinymce>
    </div>

    <div class="set-item">
      <p class="title">样式基础设置</p>
      <SpPickerColor
        v-model="curComponent.backgroundColor"
        :isGradient="true"
        label="背景颜色"
      />
      <SpSlider
        v-if="havePageMx"
        v-model="curComponent.pageMx"
        label="页面边距"
      />
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/TinymceNew";
import SpSlider from "../../../components/SpSlider";
import SpPickerColor from "../../../components/SpPickerColor";
export default {
  inject: ["control"],
  components: { Tinymce, SpPickerColor, SpSlider },
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    },
    havePageMx() {
      const flag = "pageMx" in this.curComponent;
      if (!flag) {
        this.$set(this.control.curComponent, "pageMx", 15);
      }
      return "pageMx" in this.curComponent;
    }
  },
  data() {
    return {
      html: ""
    };
  },
  methods: {
    change(content) {
      this.curComponent.html = content;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    p {
      font-size: 10px;
      color: #999999;
      margin-top: 4px;
    }
  }
  .editor {
    padding: 22px 24px 0px 24px;
  }

  > .set-item {
    padding: 30px 24px 0px 24px;
    > .title {
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/RichText/Attr.vue